var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module windy
 */
import BaseImageLayer from 'ol/layer/BaseImage.js';
import WindyLayerRenderer from './WindyImageLayerRenderer.js';
/**
 * @classdesc
 * Layer for rendering vector data as a heatmap.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @fires import("../render/Event.js").RenderEvent
 * @api
 */
var WindyImageLayer = /** @class */ (function (_super) {
    __extends(WindyImageLayer, _super);
    /**
     * @param {import("./BaseImage.js").Options=} opt_options Layer options.
     */
    function WindyImageLayer(opt_options) {
        var _this = _super.call(this, opt_options) || this;
        _this.density_ = opt_options.density ? opt_options.density : 2000;
        _this.thick_ = opt_options.thick ? opt_options.thick : 1;
        _this.length_ = opt_options.length ? opt_options.length : 50;
        return _this;
    }
    WindyImageLayer.prototype.getDensity = function () {
        return this.density_;
    };
    WindyImageLayer.prototype.setDensity = function (density) {
        this.density_ = parseFloat(density);
        this.getRenderer().setDensity(this.density_);
    };
    WindyImageLayer.prototype.getLength = function () {
        return this.length_;
    };
    WindyImageLayer.prototype.setLength = function (length) {
        this.length_ = parseFloat(length);
    };
    WindyImageLayer.prototype.getThick = function () {
        return this.thick_;
    };
    WindyImageLayer.prototype.setThick = function (thick) {
        this.thick_ = parseFloat(thick);
        this.getRenderer().setThick(this.thick_);
    };
    /**
     * Create a renderer for this layer.
     * @return {WindyLayerRenderer} A layer renderer.
     */
    WindyImageLayer.prototype.createRenderer = function () {
        var that = this;
        return new WindyLayerRenderer(this, {
            vertexShader: "\n        precision highp float;\n        \n        uniform mat4 u_projectionMatrix;\n        uniform mat3 u_PMatrix;\n        uniform float u_resolution;\n\n        attribute vec2 a_position;\n        attribute vec2 a_offset;\n        attribute float a_distance;\n        attribute float a_start;\n        attribute float a_side;\n        attribute float a_speed;\n\n        varying float v_distance;\n        varying float v_start;\n        varying float v_side;\n        varying float v_speed;\n\n        const float PIXEL = 2.5;\n\n        void main() {\n            v_distance = a_distance;\n            v_side = a_side;\n            v_start = a_start;\n            v_speed = a_speed;\n\n            gl_Position = u_projectionMatrix * vec4(a_position + (PIXEL * u_resolution * a_offset), 0.0, 1.0);\n        }",
            fragmentShader: "\n        precision highp float;\n\n        uniform float u_c_time;\n        uniform float u_resolution;\n        uniform float u_tail_length;\n        // uniform float u_tail_thick;\n        uniform vec4 u_color;\n\n        varying float v_distance;\n        varying float v_start;\n        varying float v_side;\n        varying float v_speed;\n\n        const float TRAIL_SPEED = 20.0;\n        // const float TRAIL_LENGTH = 10.0;\n        const float TRAIL_CYCLE = 200.0;\n\n        void main() {\n            float length = u_tail_length; //  + v_speed * u_tail_thick;\n            float speed = TRAIL_SPEED + v_speed * 7.0;\n            \n            float d = mod((v_distance + v_start) / u_resolution - (u_c_time * speed), TRAIL_CYCLE);\n            float a1 = d < length ? (d / length) : 0.0;\n            float a2 = exp(-abs(v_side) * 3.0);\n            float a = a1 * a2;\n            gl_FragColor = u_color * a; \n        }",
            uniforms: {
                u_color: [1.0, 1.0, 1.0, 0.8],
                u_c_time: function () {
                    // console.log(` u_c_time = ${performance.now()}`)
                    return performance.now() / 1000.0;
                },
                u_tail_length: function () {
                    // console.log(` u_c_time = ${performance.now()}`)
                    return that.length_;
                }
            },
        });
    };
    return WindyImageLayer;
}(BaseImageLayer));
export default WindyImageLayer;
//# sourceMappingURL=WindyImageLayer.js.map